import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getTasks: builder.query({
			query: () => "/tasks",
		}),
        getTask: builder.query({
            query: (id) => `/tasks/${id}`
        }),
		addTask: builder.mutation({
			query: (taskData) => ({
				url: "/tasks",
				method: "POST",
				body: taskData,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const response = await queryFulfilled;

				if (response?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getTasks",
							undefined,
							(draft) => {
								draft.push(response.data);
							}
						)
					);
				}
			},
		}),
		deleteTask: builder.mutation({
			query: (id) => ({
                url: `/tasks/${id}`,
                method: "DELETE",
            }),
            async onQueryStarted(id, { queryFulfilled, dispatch }) {
                // delete optismatically 
                const patchResult = dispatch(
                    apiSlice.util.updateQueryData(
                        "getTasks",
                        undefined,
                        (draft) => {
                            const indexToDelete = draft.findIndex(task => task.id == id);
                            if (indexToDelete !== -1) {
                                draft.splice(indexToDelete, 1);
                            }
                        }
                    )
                );

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo();
                }
            }
		}),
        changeStatus: builder.mutation({
            query: ({id, status}) => ({
                url: `/tasks/${id}`,
                method: "PATCH",
                body: {
                    status: status
                }
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // update optismatically 
                const patchResult = dispatch(
                    apiSlice.util.updateQueryData(
                        "getTasks",
                        undefined,
                        (draft) => {
                            let taskToUpdate = draft.find(task => task.id == arg.id);
                            if (taskToUpdate) {
                                taskToUpdate.status = arg.status;
                            }
                        }
                    )
                );

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo();
                }
            }
        }),
        editTask: builder.mutation({
            query: ({id, data}) => ({
                url: `/tasks/${id}`,
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const response = await queryFulfilled;

				if (response?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getTasks",
							undefined,
							(draft) => {
                                let indexToUpdate = draft.findIndex(task => task.id == arg.id);
                                if (indexToUpdate !== -1) {
                                    draft[indexToUpdate] = response.data;
                                }
							}
						)
					);

                    dispatch(
						apiSlice.util.updateQueryData(
							"getTask",
							arg.id.toString(),
							(draft) => {
                                Object.assign(draft, response.data);
							}
						)
					);
				}
			},
        })
	}),
});

export const { 
    useGetTasksQuery, 
    useGetTaskQuery,
    useAddTaskMutation, 
    useDeleteTaskMutation,
    useChangeStatusMutation,
    useEditTaskMutation
} = tasksApi;
